import { css } from "@emotion/react"
import React from "react"
import {
  Instagram,
  Linkedin,
  Twitter,
} from "../components/defaults/assets/svg/social"
import { wrapper } from "../components/defaults/styles/elements"
import mq from "../components/defaults/styles/mediaquerys"
import { color } from "../components/defaults/styles/theme"
import Link from "./link"
import StartupLogo from "./main/logo-startup"
import {
  TwitterLinkHandler,
  HandleDisplayLinks,
} from "./defaults/filters/linkHandler"
import { sortProgram } from "./defaults/filters/sort"
import Flags from "../data/raw/flags"
import Download from "../components/defaults/assets/svg/download.svg"

export const styleInfoFrame = css`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  ${mq[2]} {
    align-items: flex-start;
  }
`

export const styleInfoEl = css`
  /* max-width: 30rem; */
  flex: 1 0 30rem;
  z-index: 1;
  border: 1px solid ${color.accent_light};
  ${mq[2]} {
    max-width: 30rem;
  }
`

export const ListTitelEl = ({ className, children }) => {
  return (
    <p
      className={className}
      css={css`
        font-size: 0.75em;
        letter-spacing: 0.04em;
        margin-bottom: 0;
        color: ${color.main_dark};
        opacity: 0.5;
        margin-bottom: 0.5em;
        font-weight: 500;
      `}
    >
      {children}
    </p>
  )
}

export const ProfileInfoTop = ({ svg, id }) => {
  return (
    <>
      <div
        css={[
          styleInfoEl,
          css`
            width: 100%;
            background: white;
            max-height: 12rem;
            height: 12rem;
            border-top-left-radius: 5px;
            border-top-right-radius: 5px;
            border-bottom: none;
            margin-bottom: -5rem;
            display: flex;
            justify-content: center;
            align-items: center;
          `,
        ]}
      >
        <div
          css={css`
            width: 50%;
            max-width: 13rem;
            height: 50%;
            svg {
              width: 100%;
              height: 100%;
              fill: black;
            }
          `}
        >
          {svg ? svg : id ? <StartupLogo id={id} /> : ""}
        </div>
      </div>
    </>
  )
}

const ProfileInfoBottom = ({ data, id }) => {
  return (
    <div
      css={[
        styleInfoEl,
        css`
          background: white;
          width: 100%;
          border-top: none;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          padding: 0 1.5em 2.5em;
          position: relative;
          ${mq[2]} {
            padding: 0 2.5em 2.5em;
          }
        `,
      ]}
    >
      <ProfileMainListEl title="Company Name" content={data.name} />
      <ProfileDefault
        title="Headquarters"
        content={
          data.hq_city ? data.hq_country + ", " + data.hq_city : data.hq_country
        }
      />
      <ProfileTypeInline
        css={css`
          padding: 1em 0;
          ${mq[2]} {
            display: none;
          }
        `}
        type={data.type}
      />
      {/* <ProfileDate date={data.start_date} /> */}
      {data.start_date ? (
        <ProfileDefault
          title="Partner of STARTUP AUTOBAHN since"
          content={data.start_date}
        />
      ) : null}
      <ProfilePrograms program_string={data.program} />
      <ProfileWebsite url={data.url} />
      <ProfileSocialCard
        twitter={data.twitter}
        linkedin={data.linkedin}
        instagram={data.instagram}
      />

      {/* <div
          css={css`
            position: absolute;
            top: calc(100% + 0.5rem);
            left: 2.5rem;
            font-size: 0.5em;
            opacity: 0.5;
          `}
        >
          <p>{id}</p>
        </div> */}
    </div>
  )
}

export const ProfileMainListEl = ({ title, content }) => {
  return (
    <div
      css={css`
        width: 100%;
        border-radius: 5px;
        border: 1px solid ${color.accent_light};
        margin-bottom: 1.5em;
        p {
          margin-bottom: 0;
          padding: 0.5em;
        }
      `}
    >
      <p
        css={css`
          background: ${color.accent_light};
          display: block;
          font-size: 0.75em;
          font-weight: 500;
          letter-spacing: 0.04em;
        `}
      >
        {title}
      </p>
      <p
        css={css`
          font-weight: 500;
        `}
      >
        {content}
      </p>
    </div>
  )
}

// const ProfileDate = ({date}) => {
//     return (
//       <div
//         css={css`
//           padding: 1em 0 .5em;
//         `}
//       >
//         <ListTitelEl>Partner of STARTUP AUTOBAHN since</ListTitelEl>
//         <p
//           css={css`
//             margin-bottom: 0;
//             font-weight: 600;
//             font-size: 1.5em;
//             line-height: 1em;
//           `}
//         >
//           {date}
//         </p>
//       </div>
//     )
// }

export const ProfilePressRelease = props => {
  const { data } = props

  return (
    <div
      css={css`
        background: ${color.accent_light};
        border-radius: 5px;
        padding: 1em;
        display: flex;
        margin-bottom: 3em;
        justify-content: space-between;
        flex-wrap: wrap;
        min-width: 0;
        width: 100%;
        /* ${mq[0]} {
        flex-direction: row;
      } */
      `}
    >
      {data.localFiles.map((e, index) => (
        <Link
          key={index}
          to={e.publicURL}
          target="_blank"
          css={css`
            padding: 1em;
            border-radius: 5px;
            background: white;
            text-decoration: none;
            display: flex;
            align-items: center;
            min-width: 0;
            overflow: hidden;
            flex: 0 0 100%;
            :not(:nth-of-type(-n + 1)) {
              margin-top: 1em;
            }
            ${mq[0]} {
              flex: 0 0 calc(100% / 2 - 0.5em);
              :not(:nth-of-type(-n + 1)) {
                margin-top: 0;
              }
              :not(:nth-of-type(-n + 2)) {
                margin-top: 1em;
              }
            }
            ${mq[2]} {
              flex: 0 0 100%;
              :not(:nth-of-type(-n + 1)) {
                margin-top: 1em;
              }
            }
            ${mq[3]} {
              flex: 0 0 calc(100% / 2 - 0.5em);
              :not(:nth-of-type(-n + 1)) {
                margin-top: 0;
              }
              :not(:nth-of-type(-n + 2)) {
                margin-top: 1em;
              }
            }
          `}
        >
          <div
            css={css`
              flex: 0 1 auto;
              overflow: hidden;
              display: flex;
              flex-direction: column;
            `}
          >
            <p
              css={css`
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                display: inline-block;
                max-width: 100%;
                margin: 0;
                font-size: 0.85em;
                color: ${color.main_dark};
              `}
            >
              {e.name}
            </p>

            {["_en", "_EN", "_de", "_DE"].some(v => e.name.includes(v)) ? (
              <p
                css={css`
                  font-size: 0.75em;
                  color: ${color.main_dark};
                  opacity: 0.5;
                  margin: 0;
                `}
              >
                Language:{" "}
                {["_en", "_EN"].some(v => e.name.includes(v))
                  ? "english"
                  : "german"}{" "}
              </p>
            ) : null}

            <p
              css={css`
                font-size: 0.75em;
                color: ${color.main_dark};
                opacity: 0.5;
                margin: 0;
              `}
            >
              File-Type: {e.extension}
            </p>
          </div>
          <div
            css={css`
              flex: 1 0 auto;
              justify-content: flex-end;
              display: flex;
            `}
          >
            <div
              css={css`
                border-radius: 30px;
                width: 2.5rem;
                height: 2.5rem;
                margin-left: 1em;
                border: 1px solid ${color.plue400};
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all ease-in-out 0.4s;
                svg {
                  stroke: ${color.plue400};
                  width: 40%;
                  height: auto;
                }
                &:hover {
                  background: ${color.plue400};
                  svg {
                    stroke: ${color.white};
                  }
                }
              `}
            >
              <Download />
            </div>
          </div>
        </Link>
      ))}
    </div>
  )
}

export const ProfileTags = ({ content, className }) => {
  return (
    <p
      className={className}
      css={css`
        font-size: 0.75em;
        margin: 0;
        padding: 0.4em;
        background: ${color.accent_light};
        display: inline-block;
        border-radius: 2px;
        line-height: 1em;
        font-weight: 600;
        letter-spacing: 0.03em;
        margin-right: 0.5em;
        margin-bottom: 0.5em;
      `}
    >
      {content}
    </p>
  )
}

export const ProfilePrograms = ({ program_string }) => {
  let programs = []
  if (program_string) {
    programs = sortProgram(program_string, ",")
  }

  return (
    <div
      css={css`
        padding: 1em 0;
      `}
    >
      <ListTitelEl>Programs participated in</ListTitelEl>
      <div
        css={css`
          line-height: 0;
          margin-top: 0.5em;
          /* display: flex; */
        `}
      >
        {programs
          ? programs.map((item, index) => (
              <ProfileTags content={item} key={index} />
            ))
          : ""}
      </div>
    </div>
  )
}

export const ProfileWebsite = ({ url }) => {
  return (
    <div
      css={css`
        padding: 1em 0;
      `}
    >
      <ListTitelEl
        css={css`
          margin-bottom: 0;
        `}
      >
        Official Website
      </ListTitelEl>
      {url ? (
        <Link
          to={TwitterLinkHandler(url)}
          css={css`
            color: ${color.main_dark};
            text-decoration: none;
          `}
        >
          {HandleDisplayLinks(url)}
        </Link>
      ) : (
        ""
      )}
      {/* <Link to={`https://`+ url} css={css`
            color: ${color.main_dark};
            text-decoration: none;
        `}>{url}</Link> */}
    </div>
  )
}

export const ProfileDefault = ({ title, content }) => {
  return (
    <div
      css={css`
        padding: 1em 0;
      `}
    >
      <ListTitelEl
        css={css`
          margin-bottom: 0;
        `}
      >
        {title}
      </ListTitelEl>
      <p
        css={css`
          color: ${color.main_dark};
          margin: 0;
        `}
      >
        {content}
      </p>
    </div>
  )
}

export const ProfileHorizontal = ({
  type,
  twitter,
  linkedin,
  instagram,
  startup,
}) => {
  return (
    <div
      css={[
        wrapper,
        css`
          display: none;
          align-items: center;
          justify-content: space-between;
          height: 100%;
          padding: 0 1rem 0 34rem;
          ${mq[2]} {
            display: flex;
          }
        `,
      ]}
    >
      <ProfileType type={type} startup={startup} />
      <ProfileSocial
        twitter={twitter}
        linkedin={linkedin}
        instagram={instagram}
      />
    </div>
  )
}

export const ProfileSocialCard = ({ twitter, linkedin, instagram }) => {
  return (
    <div
      css={css`
        margin: 1em 0;
        ${mq[2]} {
          display: none;
        }
      `}
    >
      <ListTitelEl>Social Media</ListTitelEl>
      <ProfileSocial
        css={css`
          margin-top: 0.75em;
          a {
            margin-left: 0;
            margin-right: 2em;
          }
        `}
        twitter={twitter}
        linkedin={linkedin}
        instagram={instagram}
      />
    </div>
  )
}

const ProfileType = ({ className, type, startup }) => {
  return (
    <div className={className}>
      <p
        css={css`
          background: ${type[0] === "Mobility"
            ? color.e23rose
            : type[0] === "Production"
            ? color.e23violette
            : type[0] === "Enterprise"
            ? color.e23blue
            : type[0] === "Sustainability"
            ? color.e23green
            : color.accent_light};
          margin-bottom: 0;
          padding: 0.45rem 1em;
          display: inline-block;
          line-height: 1em;
          font-size: 0.85em;
          font-weight: 600;
          border-radius: 5px;
          letter-spacing: 0.04em;
        `}
      >
        {type} {startup ? "Startup" : "Partner"}
      </p>
    </div>
  )
}

export const ProfileTypeInline = ({ className, type, startup, title }) => {
  let content = ""
  if (startup) {
    content = type + " Vertical"
  } else content = type + ` Partner`

  return (
    <div className={className}>
      <ListTitelEl>{title ? title : "Partnership Type"}</ListTitelEl>
      <ProfileTags
        content={content}
        css={[
          css`
            background: ${type[0] === "Mobility"
              ? color.e23rose
              : type[0] === "Production"
              ? color.e23violette
              : type[0] === "Enterprise"
              ? color.e23blue
              : type[0] === "Sustainability"
              ? color.e23green
              : color.accent_light};
          `,
        ]}
      />
    </div>
  )
}

const ProfileSocial = ({ className, twitter, linkedin, instagram }) => {
  return (
    <div
      className={className}
      css={css`
        display: flex;
        align-items: center;
        line-height: 1em;
        a {
          height: 0.85rem;
          display: block;
          margin-left: 1em;
          opacity: 0.2;
          &[data-active] {
            opacity: 1;
          }
          svg {
            fill: ${color.main_dark};
            height: 100%;
            width: auto;
          }
        }
      `}
    >
      <Link to={linkedin} data-active={linkedin ? true : undefined}>
        <Linkedin />
      </Link>
      <Link to={twitter} data-active={twitter ? true : undefined}>
        <Twitter />
      </Link>
      <Link to={instagram} data-active={instagram ? true : undefined}>
        <Instagram />
      </Link>
    </div>
  )
}

export const ProfileHeader = ({ data, svg, id }) => {
  return (
    <>
      <section
        css={css`
          background: ${color.main_dark};
          width: 100%;
          min-height: 25rem;
          display: flex;
          justify-content: flex-end;
          flex-direction: column;
          position: relative;
          &:after {
            content: "";
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 1px;
            background: ${color.accent_light};
          }
        `}
      >
        <div css={[wrapper, styleInfoFrame, css``]}>
          <ProfileInfoTop svg={svg} />
        </div>

        <div
          css={css`
            height: 5rem;
            width: 100%;
            background: white;
          `}
        >
          <ProfileHorizontal
            type={data.type}
            twitter={data.twitter}
            linkedin={data.linkedin}
            instagram={data.instagram}
          />
        </div>
      </section>

      <div
        css={css`
          background: ${color.main_light};
          width: 100%;
          padding-bottom: 5em;
        `}
      >
        <div
          css={[
            wrapper,
            styleInfoFrame,
            css`
              flex-direction: column;
              ${mq[2]} {
                flex-direction: row;
              }
            `,
          ]}
        >
          <ProfileInfoBottom data={data} id={id} />

          {data.description ? (
            <div
              css={css`
                padding: 3rem 0 0;
                align-self: flex-start;
                width: 100%;
                overflow: hidden;
                ${mq[2]} {
                  padding-left: 3rem;
                  padding-right: 0;
                  padding-top: 3rem;
                }
              `}
            >
              {" "}
              {Flags.features.pressrelease &&
              data.pressrelease &&
              data.pressrelease.localFiles.length > 0 ? (
                <>
                  <ListTitelEl
                    css={css`
                      margin-bottom: 1.25em;
                    `}
                  >
                    Press Release by {data.name}
                  </ListTitelEl>
                  <ProfilePressRelease data={data.pressrelease} />
                </>
              ) : null}
              <ListTitelEl>Official Statement by {data.name}</ListTitelEl>
              <div
                css={css`
                  max-width: 45rem;
                  p {
                    margin: 0;
                    padding-bottom: 1em;
                    font-size: 0.85em;
                    line-height: 1.8em;
                    ${mq[1]} {
                      font-size: 0.95em;
                    }
                  }c
                `}
                dangerouslySetInnerHTML={{
                  __html: data.description.childMarkdownRemark.html,
                }}
              ></div>
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    </>
  )
}
